export const REGEX = {
	ONLY_NUMBER: /^[\d]+$/,
	EMAIL: /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/,
	PASSWORD_OLD: /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+{}[\]:;<>,.?~\\/-]{8,}$/,
	PASSWORD_: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
	PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#!$%^&*()_+{}:;<>,.?~-])[A-Za-z\d@#!$%^&*()_+{}:;<>,.?~-]{8,}$/,
	TEMPORARY_PASSWORD: /^[a-zA-Z0-9]+$/,
	DISPLAY_NAME: /^[a-zA-Z0-9\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/,
};

export enum ActionTypeEnumCart {
	REMOVE = 'REMOVE',
	ADD = 'ADD',
}
export enum TypeEnumPolicy {
	PERSONAL_INFORMATION_HANDLING_POLICY = 'PERSONAL_INFORMATION_HANDLING_POLICY',
	ACCOUNT_DELETION_GUIDE = 'ACCOUNT_DELETION_GUIDE',
	MEMBERSHIP_EXIT_TERMS = 'MEMBERSHIP_EXIT_TERMS',
	OTHERS = 'OTHERS',
	TERMS_OF_USE = 'TERMS_OF_USE',
}